import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentEmail.SendEmail.IRequest;
type Response = Api.Finance.ContractRefundPaymentEmail.SendEmail.IResponse;
type Params = Api.Finance.ContractRefundPaymentEmail.SendEmail.IParams;
type Headers = Api.Finance.ContractRefundPaymentEmail.SendEmail.IHeaders;
const url = '/api/Finance/ContractRefundPaymentEmail/SendEmail/:contractRefundPaymentId';
export default async function contractRefundPaymentEmailSendEmailApi({
  body,
  params,
}: {
  body: Request;
  params: Params;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { contractRefundPaymentId: params.contractRefundPaymentId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
